import styled from 'styled-components';
import color from '../utils/style/color';
import space from '../utils/style/space';

const ProfileEditModalBackground = styled.div`
  box-sizing: border-box;
  width: 500px;
  padding: ${space.xxxl}px;
  background-color: ${color.gray.xxxxBright};

  @media screen and (max-width: 576px) {
    width: 350px;
    padding: 30px 15px;
  }
`;

export default ProfileEditModalBackground;
